import ModelTypeConstants from 'constants/ModelTypeConstants';
import {previewPlugin} from 'notebook/notes/previews/PreviewPluginFactory';

// @ts-expect-error
import AnnotationPreview from './AnnotationPreview';
// @ts-expect-error
import PrimerPairPreview from './PrimerPairPreview';
// @ts-expect-error
import SequenceAnalysisPreview from './SequenceAnalysisPreview';
// @ts-expect-error
import SequencePreview from './SequencePreview';
// @ts-expect-error
import SequencePrimerPreview from './SequencePrimerPreview';

const PREVIEWS_BY_TYPE = {
  [ModelTypeConstants.SEQUENCE]: SequencePreview,
  [ModelTypeConstants.ANNOTATION]: AnnotationPreview,
  [ModelTypeConstants.PRIMER_PAIR]: PrimerPairPreview,
  [ModelTypeConstants.SEQUENCE_ANALYSIS]: SequenceAnalysisPreview,
  [ModelTypeConstants.SEQUENCE_PRIMER]: SequencePrimerPreview,
};

export const SEQUENCE_PREVIEW_PLUGINS = Object.entries(PREVIEWS_BY_TYPE).map(([type, preview]) =>
  previewPlugin({type, preview})
);
